(async function () {
               

    var recentState = null;

    async function init() {
        
        var current = get();

        if (current.language && current.language.indexOf('en') == -1)
            updateLanguage();

    }



    async function updateLanguage() {
        var current = get();

        if (recentState == null) recentState = Object.assign({}, current);

        if (current?.language != recentState?.language) {
            setTimeout(function () { window.location.reload(); }, 1000);
            return;
        }

        recentState = Object.assign({}, current);

        var labels = await getLanguageLabels();
        if (current?.language && labels.Locale.indexOf(current.language) == -1) {
            await updateToServer('language');
            window.location.reload();
        }
        console.log('updating lan');
        var labelsToChange = document.querySelectorAll('[ag-l-k]');
        if (labelsToChange)
            labelsToChange.forEach(function (item) { updateLanguageLabel(item, labels.Labels); });
    }

    async function getLanguageLabelsFromStore() {
        var currentLabelsString = window.localStorage.getItem('LOCALLABELS');
        var currentLabels = null;
        if (currentLabelsString != null)
            currentLabels = JSON.parse(currentLabelsString);
        return currentLabels;
    }

    async function setLanguageToStore(currentLabels) {
        window.localStorage.setItem('LOCALLABELS', JSON.stringify(currentLabels));
    }

    async function getLanguageLabels() {
        return new Promise(async function (resolve, reject) {
            var currentLabels = await getLanguageLabelsFromStore();
            var current = get();
            if (currentLabels != null) {
                var expiry = new Date();
                expiry.setHours(expiry.getHours() - 1);
                if (new Date(currentLabels.updatedOn) > expiry && currentLabels.Locale.indexOf(current.language) > -1) {
                    resolve(currentLabels);
                    return;
                }
            }
            currentLabels = await GET('/services/agoraClient.ashx', { type: 'LABELS' });
            currentLabels.updatedOn = new Date();
            setLanguageToStore(currentLabels);
            resolve(currentLabels);
        });
    }

    var expressionForAttribute = /ag\-l\-k\-(?<Attribute>[^\=]+)/gm;
    var expressionForAttributeValue = /\[(?<LabelID>[^\]]+)\]/gm;
    async function updateLanguageLabel(item, labels) {
        var key = item.getAttribute('ag-l-k');
        var match = null;
        if (labels[key] || expressionForAttributeValue.test(key)) {
            if (item.childNodes && item.childNodes.length == 1) {
                expressionForAttributeValue.lastIndex = 0;
                if (expressionForAttributeValue.test(key)) {
                    expressionForAttributeValue.lastIndex = 0;
                    var textContent = key;
                    while ((match = expressionForAttributeValue.exec(textContent)) != null) {
                        textContent = textContent.replace(match[0], labels[match.groups.LabelID] ? labels[match.groups.LabelID].lbl : '');
                    }
                    item.childNodes[0].textContent = textContent;
                } else {
                    item.childNodes[0].textContent = labels[key] ? labels[key].lbl : '';
                }
            }
            else {
                if (labels[key]) {
                    var dummyNode = document.createElement('span');
                    dummyNode.innerHTML = labels[key].lbl;
                    matchHtmlWithLabel(item, dummyNode);
                }
            }
        }
        for (var i = 0; i < item.attributes.length; i++) {
            var attribute = item.attributes[i];
            expressionForAttribute.lastIndex = 0;
            if ((match = expressionForAttribute.exec(attribute.name)) != null) {
                var attributeIdentifier = match.groups.Attribute;
                var attributeValue = attribute.value;
                while ((match = expressionForAttributeValue.exec(attributeValue)) != null) {
                    attributeValue = attributeValue.replace(match[0], labels[match.groups.LabelID] ? labels[match.groups.LabelID].lbl : '');
                }
                item.setAttribute(attributeIdentifier, attributeValue);
            }
        }
        if (item && item != null)
            item.dispatchEvent(new CustomEvent('ag.language.update.item'));

    }

    async function matchHtmlWithLabel(item, dom) {
        for (var i = 0; i < dom.childNodes.length; i++) {
            if (dom.childNodes[i]?.textContent && item.childNodes[i]?.textContent)
                item.childNodes[i].textContent = dom.childNodes[i]?.textContent;
            else if (i < dom.childNodes.length && i < item.childNodes.length)
                matchHtmlWithLabel(item.childNodes[i], dom.childNodes[i]);
            else return;
        }
    }

    


    function get() {
        var value = window.localStorage['AGLANGUAGE'];
        var currentValue = {};
        if (value && value != '') currentValue = JSON.parse(value);
        return currentValue;
    }


    async function GET(serviceUrl, data) {
        var queryString = '';
        for (var key in data) {
            queryString = queryString + ((queryString != '' ? '&' : '') + key + '=' + data[key]);
        }
        serviceUrl += serviceUrl.indexOf('?') > -1 ? '&' : '?' + queryString;
        var request = await fetch(serviceUrl, {
            method: "GET",
            cache: "no-cache",
            headers: {
                "Content-Type": "application/json",
            }
        });

        return request.json();
    }


    window.agLanguage = {

        refreshLocale: updateLanguage

    }


    init();

})();